// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__1OT4g","toolbar":"Main_toolbar__1a9Y8","editor":"Main_editor__3i7SS"};